module.exports = __webpack_public_path__ + "static/pghero-home-183b6f8f43179bc74f3d89b052628a84.png";